import React, { useCallback, useState } from 'react';
import SelectionButton, { SelectionButtonProps } from './SelectionButton';

const styles = require('./SelectionButton.module.scss');

export interface SelectionButtonGroupProps {
  className?: string;
  inputName?: string;
  label?: string;
  onSelectionChange?: (selectedValue: string) => void;
  options: Array<SelectionButtonProps>;
  required?: boolean;
}

const SelectionButtonGroup: React.FC<SelectionButtonGroupProps> = ({
  className,
  inputName,
  label = 'Select an option',
  onSelectionChange,
  options,
  required,
}) => {
  const [selectedId, setSelectedId] = useState<string>('');

  const handleSelect = useCallback((id: string, value: string) => {
    setSelectedId(id);
    onSelectionChange?.(value);
  }, [onSelectionChange]);

  const selectedValue = options.find(o => o.id === selectedId)?.value || '';

  return (
    <div
      className={className}
      role="radiogroup"
      aria-label={label}
      aria-required={required || undefined}
    >
      {inputName && (
        <input
          type="hidden"
          name={inputName}
          value={selectedValue}
          required={required}
        />
      )}
      <div className={styles.group}>
        {options.map(option => (
          <SelectionButton
            key={option.id}
            {...option}
            role="radio"
            selected={selectedId === option.id}
            onClick={() => handleSelect(option.id || '', option.value || '')}
          />
        ))}
      </div>
    </div>
  );
};

export default SelectionButtonGroup;
